import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { IApiPagination } from "../../../interfaces/IPagination";
import {
  GetDistributorSpecialPricesResponse,
  DistributorSpecialPriceFilterType,
  TDistributorSpecialPrice,
  TDistributorSpecialPriceForm,
} from "../types/distributorSpecialPrice.types";
import axiosTeethTab from "../../../services/apiCall";

type DistributorSpecialPriceApiInterface = {
  getDistributorSpecialPrices: (
    filter: DistributorSpecialPriceFilterType,
    pagination: IApiPagination,
  ) => Promise<ApiResponse<GetDistributorSpecialPricesResponse>>;
  saveDistributorSpecialPrice: (
    productPrice: TDistributorSpecialPriceForm,
  ) => Promise<ApiResponse<TDistributorSpecialPrice>>;
  getDistributorSpecialPriceById: (
    id: string,
  ) => Promise<ApiResponse<TDistributorSpecialPrice>>;
  enable: (id: string) => Promise<ApiResponse<TDistributorSpecialPrice>>;
  disable: (id: string) => Promise<ApiResponse<TDistributorSpecialPrice>>;
};

const distributorSpecialPriceApi: DistributorSpecialPriceApiInterface = {
  getDistributorSpecialPrices: async (filter, pagination) => {
    const endpoint = "distributor-special-prices";
    return await axiosTeethTab.get(endpoint, {
      params: {
        filter,
        pagination,
      },
    });
  },
  saveDistributorSpecialPrice: async (distributorSpecialPrice) => {
    const endpoint = distributorSpecialPrice._id
      ? `distributor-special-prices/${distributorSpecialPrice._id}`
      : "distributor-special-prices";
    return await axiosTeethTab.post<TDistributorSpecialPrice>(
      endpoint,
      distributorSpecialPrice,
    );
  },
  getDistributorSpecialPriceById: async (id: string) => {
    const endpoint = `distributor-special-prices/${id}`;
    return await axiosTeethTab.get<TDistributorSpecialPrice>(endpoint);
  },
  enable: async (id: string) => {
    const endpoint = `distributor-special-prices/${id}/enable`;
    return await axiosTeethTab.patch<TDistributorSpecialPrice>(endpoint);
  },
  disable: async (id: string) => {
    const endpoint = `distributor-special-prices/${id}/disable`;
    return await axiosTeethTab.patch<TDistributorSpecialPrice>(endpoint);
  },
};

export default distributorSpecialPriceApi;
